import { SProduct } from "@/__generated__/graphql";
import ShoppingBagIcon from "@/app/_components/Icons/ShoppingBagIcon";
import { useCartHasProduct } from "@/redux/features/cart/hooks";
import { Add, Circle, MoreVert } from "@mui/icons-material";
import { Box, Button, Card, CardContent, IconButton, Popper, Typography, useTheme } from "@mui/material";
import React from "react";
type Props = {
  productId: string;
};

export default function ProductCardInBasketLogo({ productId }: Props) {
  const cartHasProduct = useCartHasProduct(productId);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 8, // Adjust to fine-tune the position
        left: 8, // Adjust to fine-tune the position
        zIndex: 1, // Ensure it's on top of the image
        display: {
          xs: "none",
          md: "flex",
        },
        flexDirection: "column",
        gap: 0.7,
      }}
    >
      {cartHasProduct && (
        <>
          <Box
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            sx={{
              borderRadius: 3,

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              backgroundColor: "grey.600",
              color: "white.main",
            }}
          >
            <ShoppingBagIcon />
          </Box>
          <Popper open={open} anchorEl={anchorEl} placement="left" modifiers={[]}>
            <Card variant="outlined" sx={{ px: 1, borderRadius: 3 }}>
              <Typography variant="caption">موجود در سبد خرید شما</Typography>
            </Card>
          </Popper>
        </>
      )}
    </Box>
  );
}
